<template>
    <ValidationProvider
        v-slot="{ classes, errors }"
        :rules="rules"
        :name="name"
        ref="provider"
        :vid="name"
        mode="eager"
        class="w-full"
        :class="$attrs['class']"
        tag="div"
    >
        <div class="digi-currency w-full" :class="classes">
            <label class="form-label" :for="name" v-html="label"></label>
            <div class="form-input -m-2">
                <div class="form-input-inner p-2 w-full">
                    <div
                        class="input-wrapper w-full relative textbox flex h-12 border-gray-500 border focus:border-green-500 outline-none"
                    >
                        <span
                            class="currency-textbox-left flex text-lg flex-grow-0 w-12 justify-center items-center border-0 border-r border-gray-500 border-solid flex-shrink-0"
                        >£</span>
                        <input
                            :name="name"
                            type="tel"
                            :value="value"
                            @change="handleChange"
                            @input="handleInput"
                            @blur="handleBlur"
                            v-bind="attributes"
                            class="flex p-4 h-12 flex-grow outline-none focus:outline-none text-lg"
                            v-number-only="true"
                        />
                        <span class="flex flex-grow-0 p-4 items-center" v-if="extralabel" v-html="extralabel"></span>
                    </div>
                </div>
            </div>
            <signpost
                :signPostId="checkSignpostId"
            >
            </signpost>
            <div v-if="microtext" class="form-microtext mt-4">
                <small v-html="microtext"></small>
            </div>
        </div>
    </ValidationProvider>
</template>
 
<script>
import Signpost from './signpost'
export default {
    components: {
        signpost: Signpost,
    },
    data() {
        return {
            showSignposting: false,
            signPostId: null,
        };
    },
    computed: {
        checkSignpostId() {
            if (this.signPostId) {
                return this.signPostId;
            }
        }
    },
    props: {
        rules: {
            default: () => {
                return {};
            },
        },
        attributes: {
            default: () => {
                return {};
            },
        },
        value: {
            default: ""
        },
        name: {
            default: ""
        },
        label: {
            default: ""
        },
        extralabel: {
            default: ""
        },
        options: {
            default: () => {
                return {};
            },
            type: Object
        },
        valid: {
            default: null
        },
        type: {
            default: "text"
        },
        microtext: {
            default: null
        },
        customer: Object,
        test: {
            default: false,
        }
    },
    created() {
        if (this.value) {
            this.$nextTick(() => {
                if (this.value) {
                    this.$refs.provider.validate(this.value);
                } else {
                    this.$refs.provider.reset();
                }
            });
        }
    },
    methods: {
        handleChange(e) {
            this.$emit("change", e.target.value);
            
        },
        handleInput(e) {
            this.$emit("input", e.target.value);
        },  
        handleBlur(e) {
            if (this.value === null) {
                window.amplitude.currencyInputInteractionEvent(this.name, 'User has left the field blank');
            }
            if (this.value !== null) {
                // turned off this event to resolve errors
                // setTimeout(() => {
                //     window.amplitude.currencyInputInteractionEvent(this.name, this.$refs.provider.flags.valid === true ? 'valid' : 'invalid');
                // }, 500)
            }
            if (this.value !== null && this.name == "salary") {
                this.checkForSignposting();
            }
            if (this.value !== null && this.name == "housing") {
                this.checkForSignposting();
            }
        },   
        // checks whether signposting should be shown, if we want to only show for test form configs add && this.test == true
        // ensure the test parameter is set to true for the component in the form config php file
        // ensure the vue component supports the test prop, if not implement it based on the other signposting components
        // implemented by matt
        checkForSignposting() {
            if (this.name == "salary" && this.customer.age == null) {
                return;
            }
            if (this.name == "salary" && this.customer.numeric_age <= 21 && this.customer.loanamount == 10000 && this.customer.income.salary <= 977) {
                this.showSignposting = true;
                this.signPostId = 'ratio';
                window.amplitude.showSignposting('age is 21 or less, loan amount is 10000 and monthly salary is less than £977');
                return;
            }
            if (this.name == "housing" && this.value == 0 && this.customer.residential_status == 'homeowner') {
                this.showSignposting = true;
                this.signPostId = 'housing';
                return;
            }
            this.showSignposting = false;
            this.signPostId = null;
        },
    }
};
</script>
<style lang="scss">
.digi-currency.valid {
    .textbox {
        box-shadow: inset 0 0 0 1px #3dcfaf;
        border-color: #3dcfaf;
        border-width: 1px;
    }
    .currency-textbox-left {
        border-right-width: 2px;
        border-color: #3dcfaf;
    }
}

.digi-currency.invalid {
    .textbox {
        box-shadow: inset 0 0 0 1px #fc6471;
        border-color: #fc6471;
        border-width: 1px;
    }
    .currency-textbox-left {
        border-right-width: 2px;
        border-color: #fc6471;
    }
}
</style>